import { useDispatch, useSelector } from "react-redux";
import { setEventOnDataLayer } from "../utils/helper/datalayer-events-helper";
import { logBusiness } from "../store/actions/log-actions";

export default function useEvents(logPrefix, dataLayerPrefix) {
    const dispatch = useDispatch()
    const loan = useSelector((state) => state?.personalLending?.loan);
    const device = useSelector((state) => state?.customer?.device);


    const dispatchLogEvent = (logSuffix, error) => {
        dispatch(logBusiness(`${logPrefix}-${logSuffix}${error && error != '' ? `-${error}` : ''}`, null, null, null, error, device, loan?.id));
    }

    const dispatchDataLayerEvent =
        (logSuffix, error, additionalFields) => {
            setEventOnDataLayer(
                `${dataLayerPrefix}-${logSuffix}${error && error != '' ? `-${error}` : ''}`, loan, additionalFields
            );
        }

    const dispatchCompleteEvent = (logSuffix, additionalFields, error) => {
        dispatchLogEvent(logSuffix, error)
        dispatchDataLayerEvent(logSuffix, additionalFields, error)
    }

    return {
        dispatchLogEvent,
        dispatchDataLayerEvent,
        dispatchCompleteEvent
    };
}